import SelectFavouritePlayer from './SelectFavouritePlayers';

export default SelectFavouritePlayer;